import { StyleSheet } from 'aphrodite';
import { SPACE } from '@HoudiniUI/Theme/theme';
import { THEME } from '@Theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
		margin: '0 auto',
		maxWidth: 720,
		padding: THEME.spacing.lg,
		width: '100%',
	},
	description: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
	goalTextArea: {
		minHeight: 192,
		resize: 'vertical',
	},
	heading: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		margin: 0,
	},
	quotaLine: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
	},
	quotaExhausted: {
		color: THEME.colors.danger.main,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	quotaNote: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		margin: 0,
	},
	researchToggleRow: {
		alignItems: 'flex-start',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	settings: {
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		padding: SPACE[16],
	},
	settingsFields: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[24],
	},
	settingsTitle: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
		margin: 0,
	},
	skipTrigger: {
		background: THEME.colors.background.light,
		maxWidth: 320,
		width: '100%',
	},
	toggleCopy: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
});
